import { waitlistClickHandle } from './waitListhandler';

const addToBagCta = () => {
  document.querySelector('.pdp-c-atc__submit-btn')?.addEventListener('click', waitlistClickHandle);
};

export default addToBagCta;
